import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

const VISTA_PATH: Record<string, string> = {
  canales: "/app/produccion/canales",
  produccion: "/app/produccion/tablero",
  pedidos: "/app/produccion/pedidos",
  usuarios: "/app/produccion/usuarios",
};

export const Route = createFileRoute("/app/produccion")({
  validateSearch: (s: Record<string, unknown>) => ({
    vista: typeof s.vista === "string" ? s.vista : undefined,
  }),
  beforeLoad: ({ search }) => {
    const v = search.vista;
    if (v && v !== "hub" && VISTA_PATH[v]) {
      throw redirect({ to: VISTA_PATH[v] });
    }
  },
  component: () => <Outlet />,
});
